<ng-snotify></ng-snotify>
<app-loader></app-loader>
<router-outlet></router-outlet>
